import DialogTask from './DialogTask'

export default DialogTask
